import { Components } from '@mui/material/styles';
import { Theme } from '@mui/material';
import { flowTimePicker } from './timepicker.theme';

export const flowMobileTimePicker: Components<Theme>['MuiMobileTimePicker'] = {
  ...(flowTimePicker as Components<Theme>['MuiMobileTimePicker']),
  defaultProps: {
    ...(flowTimePicker.defaultProps as Components<Theme>['MuiMobileTimePicker']['defaultProps']),
    orientation: 'portrait',
    slotProps: {
      ...(flowTimePicker.defaultProps
        ?.slotProps as Components<Theme>['MuiMobileTimePicker']['defaultProps']['slotProps']),
      actionBar: {
        actions: ['cancel', 'accept'],
      },
      dialog: {
        sx: {
          '& .MuiDialog-container': {
            alignItems: 'center',
          },
          '& .MuiDialog-paper': {
            maxWidth: '360px',
            height: 'auto',
          },
        },
      },
    },
  },
};
